import { render } from "./homeOfficeLink.vue?vue&type=template&id=5915fef5&scoped=true"
import script from "./homeOfficeLink.vue?vue&type=script&lang=js"
export * from "./homeOfficeLink.vue?vue&type=script&lang=js"

import "./homeOfficeLink.vue?vue&type=style&index=0&id=5915fef5&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5915fef5"]])

export default __exports__